'use strict';

var hexToRgba = {};

exports.__exports = hexToRgba;
//# sourceMappingURL=hexToRgba.cjs.map
